import { PlaceS } from '../data/model'

export const deserializeS = (serializedS: string): PlaceS => {
  const serialized = serializedS.replace(/^s-/, '')
  const deserializedData = window.atob(serialized)
  const place = JSON.parse(
    `{"${deserializedData.replace(/;/g, '","').replace(/=/g, '":"')}"}`
  ) as PlaceS

  return {
    c: decodeURIComponent(place.c),
    id: place.id,
    lat: Number(place.lat),
    lon: Number(place.lon),
    n: decodeURIComponent(place.n),
    ph: place.ph !== undefined ? decodeURIComponent(place.ph) : undefined,
  }
}
